export function getMeta(name, prefixed=true) {
    if(!name) return;
    if(prefixed) name = `msz-${name}`;

    const elem = document.querySelector(`meta[name="${name}"]`);
    if(elem instanceof HTMLMetaElement && typeof elem.content === 'string')
        return elem.content;

    return null;
};

export function setMeta(name, value, prefixed=true) {
    if(!name) return;
    if(prefixed) name = `msz-${name}`;

    let elem = document.querySelector(`meta[name="${name}"]`);
    if(elem instanceof HTMLMetaElement) {
        if(typeof value === 'string')
            elem.content = value;
        else
            elem.remove();
    } else {
        if(typeof value !== 'string')
            return;

        elem = document.createElement('meta');
        elem.name = name;
        elem.content = value;
        document.head.appendChild(elem);
    }
};
